export const setLocalStorage = (key: string, value: any) => {
  localStorage.setItem(key, value);
};

export const getLocalStorage = (key: string) => {
  return localStorage.getItem(key);
};

export const removeLocalStorage = (key: string) => {
  localStorage.removeItem(key);
};

export const clearLocalStorage = () => {
  const retainedData: any = {};
  const retainKeys = ['sess_id'];

  // Store values of keys that need to be retained
  retainKeys.forEach((key) => {
    const value = localStorage.getItem(key);
    if (value !== null) {
      retainedData[key] = value;
    }
  });

  localStorage.clear();

  // Restore retained keys
  Object.keys(retainedData).forEach((key) => {
    localStorage.setItem(key, retainedData[key]);
  });
};
